import styled from "styled-components";
import { useContext } from "react";
import Context from "../../../../Context";
import ngoTypes from "../../../../data/ngoTypes";
import CustomButton from "../../../helperComponents/CustomButton";
import goTo from "../../../../controllers/goTo";
import CustomLabel from "../../../applicationUI/CustomLabel";
import NgoTypeButton from "../../../applicationUI/ngo/NgoTypeButton";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

const List = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 15px;

  @media (max-width: 900px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }
`;

export default function NgoPageList() {
  const { updateLoggedInUser, loggedInUser, isMobile } = useContext(Context);

  return (
    <Container>
      <CustomLabel>Explore NGOs</CustomLabel>

      <List>
        {ngoTypes.map((item) => (
          <NgoTypeButton
            key={item.value}
            item={item}
            onClick={goTo(`/accounts/?type=NGO&ngoType=${item.value}`)}
          />
        ))}
      </List>
      {/*       
      <List>
        {ngoTypes.map((item) => (
          <CustomButton
            style={{
              padding: "20px 0",
              paddingLeft: "20px",
              borderRadius: "10px",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              background: "transparent",
              border: "1px solid var(--elementDim)",
            }}
            onClick={goTo(`/accounts/?type=NGO&ngoType=${item.value}`)}
            icon={item.icon}
          >
            {item.label}
          </CustomButton>
        ))}
      </List> */}
    </Container>
  );
}
